import { render, staticRenderFns } from "./NewSearch.vue?vue&type=template&id=58fe5396"
import script from "./NewSearch.vue?vue&type=script&lang=js"
export * from "./NewSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports